/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Erreur lors de l\'annulation de l\'intégration de Twitch',
    ERROR: 'Erreur',
    FETCH_DATA: 'Récupérer des données'
  },
  HEADER: {
    DATE: 'Date',
    MESSAGE: 'Message',
    NAME: 'Nom',
    ORDER_CODE: 'Code de commande',
    ORDER_VALUE: 'Montant'
  },
  LABEL: {
    ACTIVE_SINCE: 'Actif depuis',
    INTEGRATIONS: 'Intégrations',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Autorisations Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis a l\'autorisation de créer des alertes sur Twitch pendant les streams.',
    TWITCH_INFORMATION:
      'Prozis va demander l\'autorisation de créer des alertes sur Twitch pendant les streams.',
    TWITCH_INTEGRATION: 'Intégration de Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'L\'intégration de Twitch a été annulée',
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    ORDER_CODE: 'Code de commande'
  }
};
